var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownArrow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.599,
    height: 49,
    viewBox: "0 0 32.599 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Dropdown_for_input",
    "data-name": "Dropdown for input",
    transform: "translate(0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Drop",
    transform: "translate(18.9 21.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Drop-2",
    "data-name": "Drop",
    d: "M2299.484,477.188h13.2l-6.8,8.5Z",
    transform: "translate(-2299.484 -477.188)",
    fill: "#2d335d"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_349",
    "data-name": "Line 349",
    y2: 49,
    fill: "none",
    stroke: "#e8e8e8",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownArrow);
export default __webpack_public_path__ + "static/media/dropdown-arrow.40b081146d13f22feb777ad3d7ca6abb.svg";
export { ForwardRef as ReactComponent };